import React from 'react';
import {
  array, string, func, object, bool,
} from 'prop-types';

import { Provider, connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as utils from '../../shared/utils';
import picsioConfig from '../../../../../config';
import l18n from '../../shared/strings';
import Logger from '../../services/Logger';

import Icon from '../Icon';
import store from '../../store';
import { resizePanel } from '../../store/actions/main';
import { revertRevision, attachCommentToAsset } from '../../store/actions/assets';
// import { notificationsMarkAsRead } from '../../store/actions/notifications';
import * as notificationsActions from '../../store/actions/notifications';
import { checkUserAccess } from '../../store/helpers/user';
import ConnectSlack from './ConnectSlack';

import SkeletonItem from './SkeletonItem';
import Comment from './Comment';
import Revision from './Revision';
import HistoryViewBottom from './HistoryViewBottom';
import UpgradePlanBlock from '../UpgradePlanBlock';
import helpersLink from '../Billing/Overview/Features/constants/helpersLink';

const isGuestUser = (userId) => userId === '500000000000000000000004';

class History extends React.Component {
  User = this.props.user || {};

  $bottomComment = React.createRef();

  $list = null;

  isMainApp = picsioConfig.isMainApp;

  state = {
    guestName: utils.getGuestName(),
  }

  componentDidMount() {
    this.props.notificationsActions.notificationsMarkAsRead(this.props.model._id);
  }

  componentDidUpdate() {
    const {
      historyItems, getElVideo, historyActions,
    } = this.props;
    const ElVideo = getElVideo();

    if (ElVideo && ElVideo !== this.ElVideo) {
      this.ElVideo = ElVideo;
      this.ElVideo.addEventListener('markSelected', (e) => {
        const index = historyItems.findIndex((item) => item._id === e.detail._id);
        historyActions.toggleActiveComment(index, { isVideo: true });
      });
    }
  }

    listRef = (node) => {
      this.$list = node;
      this.props.customRef.current = node;
    }

  changeGuestName = (event) => {
    event.preventDefault();
    const { target } = event;
    const { value } = target;
    const guestName = value || utils.getGuestName();
    target.value = guestName;

    utils.setGuestName(guestName);
    this.setState({ guestName });
  };

  checkMarkerDisplay = (revisionId) => picsioConfig.isMainApp
    || picsioConfig.access.revisionsShow
    || this.props.historyActions.getActiveRevisionID() === revisionId;

  onClickAddMarker = () => {
    const { nextMarkerNumber, historyActions } = this.props;
    const { getActiveRevisionID } = historyActions;

    const activeRevisionID = getActiveRevisionID();

    const { onClickAddMarker } = this.props;

    Logger.log('User', 'ActivityPanelMarkerAdd', { assetId: this.props.model._id, activeRevisionID });
    onClickAddMarker(nextMarkerNumber);
  };

  /**
   * Download revision by index in state.historyItems
   * @param {number} index
   */
    downloadRevision = (index) => {
      const { historyItems } = this.props;
      const { id, originalFilename } = historyItems[index];

      /* Find next technical revision id */
      /* Allow to download technical revisions [2020.08.20] // hotfix
     for (let i = index + 1; i < historyItems.length; i++) {
       if (historyItems[i].id !== undefined) {
         // if revision
         if (historyItems[i].technical) {
           // if technical - set id
           id = historyItems[i].id;
         } else {
           // if not technical - break
           break;
         }
       }
     }
     */

      Logger.log('User', 'ActivityPanelRevisionDownload', { revisionId: id });
      this.props.downloadRevision(id, originalFilename);
    };

    getPanelWidth = () => {
      const panelWidth = utils.LocalStorage.get('picsio.panelsWidth');
      if (panelWidth) {
        return `${panelWidth.previewView.right}px`;
      }
      return '450px';
    }

    render() {
      const { props } = this;
      const {
        lastRevisionNumber,
        isLastRevisionTechnical,
        historyActions,
        isLoaded,
        isLoadedAddComment,
        historyItems,
        nextMarkerNumber,
        revisionsWithMarkers,
        isSupportedForDiff,
        approvals,
        isApproveDisabled,
        commentsCount,
        isVideo,
        replyTo,
        lastRevisionID,
        onScrollToBottom,
        user: { _id: userId },
        markers,
      } = props;
      const {
        getActiveRevisionID,
        activateRevision,
        toggleRevisionComments,
        revertRevision,
        activateDiff,
        handleEyeClick,
        onCommentRemove,
        addReply,
        addReaction,
        changeApprove,
        addComment,
        editComment,
        cancelReply,
      } = historyActions;

      const activeRevisionID = getActiveRevisionID();
      const isRestricted = utils.isAssetRestricted(props.model.restrictSettings);
      const rolePermissions = (this.isMainApp && props.user.role.permissions) || {};
      const isAllowedApproving = this.isMainApp
      && !picsioConfig.isPim
      && props.model.permissions.approveAssets
      && (!isRestricted || (isRestricted && rolePermissions.restrictedApprove));
      const isDownloadArchiveAllowed = checkUserAccess('subscriptions', 'archive', null, props.user) && checkUserAccess('permissions', 'downloadArchive', null, props.user);

      const isCommentsShow = this.isMainApp || picsioConfig.access.commentShow;
      const { hideInternalComments } = picsioConfig.access || {};
      const { comments, obsolete: activePlanIsOld } = props.subscriptionFeatures;
      const isCommentsNotAllowed = Boolean((this.isMainApp && !comments)
    || (!this.isMainApp && !picsioConfig.access.comment));
      return (
        <div className="historyView" style={{ width: this.getPanelWidth() }}>
          <div
            role="presentation"
            className="resizer"
            onMouseDown={(event) => props.mainActions.resizePanel(event, 'previewView.right')}
          />
          <div className="historyView__list" ref={this.listRef}>
            <div className="innerHistoryList">
              <Choose>
                <When condition={!isLoaded}>
                  <>
                    <SkeletonItem />
                    <SkeletonItem />
                    <SkeletonItem />
                  </>
                </When>
                <Otherwise>
                  <>
                    <If condition={picsioConfig.isMainApp && isCommentsNotAllowed}>
                      <div className="upgradePlanContainer">
                        <UpgradePlanBlock
                          title={l18n.UPGRADE_PLAN_BLOCK.comments.title}
                          description={l18n.UPGRADE_PLAN_BLOCK.comments.description}
                          helperText={l18n.UPGRADE_PLAN_BLOCK.comments.helperText}
                          helperLink={helpersLink.comments}
                          featureName="comments"
                          redirectToBilling={activePlanIsOld}
                        />
                      </div>
                    </If>
                    <If condition={this.isMainApp && !picsioConfig.isPim}>
                      <ConnectSlack />
                    </If>
                    {historyItems.map((item, index, currentArray) => {
                      const isLastElement = (currentArray.length - 1) === index;
                      if (item.revisionNumber !== undefined) {
                        if (this.isMainApp || picsioConfig.access.revisionsShow) {
                          return (
                            <Revision
                              data={item}
                              index={index}
                              key={item.id}
                              isActive={item.id === activeRevisionID}
                              isActiveDiff={item.id === props.diffID}
                              isSupportedForDiff={isSupportedForDiff}
                              isDownloadable={
                                props.isDownloadable
                                && (!isRestricted
                                  || (isRestricted && rolePermissions.restrictedDownload))
                              && (props.model.archived ? isDownloadArchiveAllowed : true)
                              }
                              lastRevisionNumber={lastRevisionNumber}
                              setActive={activateRevision}
                              commentsWithMarkersCount={revisionsWithMarkers[item.id] || 0}
                              activeMarkersCount={props.markers.length}
                              toggleRevisionComments={toggleRevisionComments}
                              revertRevision={revertRevision}
                              download={this.downloadRevision}
                              setActiveDiff={() => activateDiff(
                                item.id,
                                item.revisionNumber,
                                historyItems.find(
                                  (item) => item.id === activeRevisionID,
                                ).revisionNumber,
                              )}
                              showMarkerIcon={isCommentsShow}
                              isApproved={approvals.includes(item.id)}
                              isVideo={this.props.isVideo}
                              addtionalClassName={item.addtionalClassName}
                              isAllowedImageUpload={
                                this.isMainApp
                                && props.model.permissions.upload
                                && !props.model.archived
                              }
                              isDiffAllowed={
                                this.isMainApp ? props.subscriptionFeatures.diffTool : true
                              }
                              isLastRevisionTechnical={isLastRevisionTechnical}
                            />
                          );
                        }
                        return null;
                      }
                      if (isCommentsShow) {
                        const {
                          _id: commentId, revisionID, replyTo, userId,
                        } = item;

                        /** Don't show comments from teammates on website if setting is set */
                        if (hideInternalComments && !isGuestUser(userId)) return null;

                        const originalComment = replyTo
                          ? historyItems.find((i) => i._id === replyTo) : null;
                        const isActive = markers.some((marker) => marker.id === commentId);
                        const showMarkerIcon = this.checkMarkerDisplay(revisionID);

                        return (
                          <Comment
                            key={commentId}
                            isLastElement={isLastElement}
                            onScrollToBottom={onScrollToBottom}
                            getElVideo={props.getElVideo}
                            assetsPermissions={props.model.permissions}
                            isVideo={isVideo}
                            index={index}
                            listNode={this.$list}
                            currentUserId={props?.user?._id}
                            teamOwnerId={props?.user?.team?._id}
                            data={item}
                            originalComment={originalComment}
                            isActive={isActive}
                            showMarkerIcon={showMarkerIcon}
                            onEyeClick={handleEyeClick}
                            onEdit={editComment}
                            onRemove={onCommentRemove}
                            addReply={addReply}
                            addReaction={addReaction}
                            isCommentsNotAllowed={isCommentsNotAllowed}
                          />
                        );
                      }
                      return null;
                    })}
                    {isLoadedAddComment && <SkeletonItem />}
                  </>
                </Otherwise>
              </Choose>
              <If condition={!this.isMainApp
              && picsioConfig.access.commentShow
              && !picsioConfig.access.revisionsShow
              && commentsCount === 0
              && isLoaded}
              >
                <div className="placeholder">
                  <Icon name="cloudChat" />
                  <div className="txt">{l18n.HISTORY.proofingCommentsPlaceholder}</div>
                </div>
              </If>
            </div>
          </div>

          <If condition={isCommentsShow}>
            <HistoryViewBottom
              getElVideo={props.getElVideo}
              modelID={this.props.model._id}
              tmpMarkers={props.tmpMarkers}
              nextMarkerNumber={nextMarkerNumber}
              markersDisabled={props.markersDisabled}
              markersLocked={getActiveRevisionID() !== lastRevisionID}
              onClickAddMarker={this.onClickAddMarker}
              isApproved={approvals.includes(activeRevisionID)}
              isApproveDisabled={isApproveDisabled}
              onChangeApprove={changeApprove}
              onSubmit={addComment}
              isVideo={props.isVideo}
              isAllowedApproving={isAllowedApproving}
              replyTo={replyTo}
              cancelReply={cancelReply}
              guestName={this.state.guestName}
              changeGuestName={this.changeGuestName}
              isCommentsNotAllowed={isCommentsNotAllowed}
              commentTimeRange={props.commentTimeRange}
              isCheckedAttachTime={props.isCheckedAttachTime}
              setAttachTime={props.setAttachTime}
              setCommentTimeRange={props.setCommentTimeRange}
            />
          </If>
        </div>
      );
    }
}

History.propTypes = {
  model: object,
  activeID: string,
  diffID: string,
  setActiveDiff: func,
  toggleMarkers: func,
  markers: array,
  tmpMarkers: array,
  isDownloadable: bool,
  onClickAddMarker: func,
  clearTmpMarkers: func,
  downloadRevision: func,
  markersDisabled: bool,
  updateModelApprove: func,
  customRef: object,
};

const mapStateToProps = (state) => ({
  user: state.user,
  subscriptionFeatures: state.user.subscriptionFeatures || {},
});
const mapDispatchToProps = (dispatch) => ({
  mainActions: bindActionCreators({ resizePanel }, dispatch),
  assetsActions: bindActionCreators({ revertRevision, attachCommentToAsset }, dispatch),
  notificationsActions: bindActionCreators(notificationsActions, dispatch),
});
const ConnectedHistory = connect(mapStateToProps, mapDispatchToProps)(History);

export default (props) => (
  <Provider store={store}>
    <ConnectedHistory {...props} />
  </Provider>
);
